import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Strong,
  Text,
  TextAlign,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

import type { PriceRow } from '../PriceBreakdownCard/PriceBreakdownCard'
import coinIcon from './assets/coin-icon.svg'

export type PricePerPortionBannerProps = {
  pricePerPortion: PriceRow
}

const Banner = withCitrusTheme(Box, () => ({
  borderRadius: '8px',
}))

/**
 * The struck price and the label are explicit flex-row siblings because Citrus's typography
 * defaults otherwise stack them vertically. The struck price takes the same ColdGrey_600 as
 * every other struck price here; the Figma export colours it white, near-invisible on mint.
 */
export const PricePerPortionBanner = ({ pricePerPortion }: PricePerPortionBannerProps) => (
  <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={2}>
    <Banner
      bg={Color.Success_50}
      paddingH={4}
      paddingV={3}
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={2}
    >
      <img src={coinIcon} alt="" width="33" height="33" />
      <Box display={Display.Flex} alignItems={AlignItems.Center} gap={1}>
        <s>
          <Text size={2} fontWeight={FontWeight.Normal} color={Color.ColdGrey_600}>
            {pricePerPortion.originalPrice}
          </Text>
        </s>
        <Text size={4} fontWeight={FontWeight.Bold} color={Color.ColdGrey_800}>
          {`${pricePerPortion.currentPrice} per portion`}
        </Text>
      </Box>
    </Banner>
    {/* Flush with the banner's own left edge at ≥1024; keeps its inset below that. */}
    <Box paddingH={[1, null, null, 0]}>
      <Box maxWidth={[null, null, null, '313px']}>
        <Text size={0} color={Color.ColdGrey_600} textAlign={TextAlign.Left}>
          <Strong size={0} color={Color.ColdGrey_600}>
            More recipes, better value.
          </Strong>
          <br />
          The price per portion drops as your box grows.
        </Text>
      </Box>
    </Box>
  </Box>
)
